import { render, staticRenderFns } from "./ValidationRequisitos.vue?vue&type=template&id=a8bc29f0&scoped=true"
import script from "./ValidationRequisitos.vue?vue&type=script&lang=ts"
export * from "./ValidationRequisitos.vue?vue&type=script&lang=ts"
import style0 from "./ValidationRequisitos.vue?vue&type=style&index=0&id=a8bc29f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bc29f0",
  null
  
)

export default component.exports